import { render, staticRenderFns } from "./FolderList.vue?vue&type=template&id=008e6ff7&scoped=true&"
import script from "./FolderList.vue?vue&type=script&lang=js&"
export * from "./FolderList.vue?vue&type=script&lang=js&"
import style0 from "./FolderList.vue?vue&type=style&index=0&id=008e6ff7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008e6ff7",
  null
  
)

component.options.__file = "FolderList.vue"
export default component.exports